import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as LogoIcon } from '../../assets/images/logo.svg';
import { ReactComponent as LogoMinimalIcon } from '../../assets/images/logo-minimal.svg';
import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import Button from '../Button/Button';
import styles from './Navbar.module.css';
import { useWindowWidth } from '../../hooks/WindowSizeContext';
import { useDrawer } from '../../App';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Clear';
import HomeIcon from '@mui/icons-material/HomeOutlined';
// import PeopleIcon from '@mui/icons-material/PeopleOutlineOutlined';
import CameraIcon from '@mui/icons-material/CameraAltOutlined';
// import MailIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
// import FAQIcon from '@mui/icons-material/HelpCenterOutlined';
import PeopleImg from '../../assets/images/people.png';
import SignoutIcon from '@mui/icons-material/LogoutOutlined';
import VideoIcon from '@mui/icons-material/OndemandVideoOutlined';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import DashboardIcon from '@mui/icons-material/SpaceDashboardOutlined';
import { isAdminUser } from '../../api/gestor';
import { handleContractCameraWhatsapp } from '../../utils/index';

export const DrawerBody = () => {
  const { toggleDrawer } = useDrawer();
  const location = useLocation();
  const hasAccessToken = !!localStorage.getItem('accessToken');
  const auth = getAuth();
  const user = auth.currentUser;

  const isActive = (path: string) => location.pathname === path;

  const onSignOff = () => {
    signOut(auth).then(() => {
      localStorage.removeItem('accessToken');
      toggleDrawer();
    });
  };

  return (
    <div className={styles.drawer_container}>
      <CloseIcon className={styles.close_icon} onClick={toggleDrawer} />
      <div className={styles.drawer_header}>
        {hasAccessToken ? (
          <Link to="/login" onClick={toggleDrawer}>
            {user?.photoURL ? (
              <img
                className={styles.profile_image}
                src={user?.photoURL}
                alt="Foto do usuário cadastrado"
              />
            ) : (
              <img src={PeopleImg} alt="Ícone padrão de usuário" />
            )}
            <h2>{user?.displayName ?? 'Usuário Logado'}</h2>
          </Link>
        ) : (
          <Link to="/login" onClick={toggleDrawer}>
            <img src={PeopleImg} alt="Ícone padrão de usuário" />
            <h2>Login</h2>
          </Link>
        )}
      </div>
      <nav>
        <ul className={styles.drawer_list}>
          <li className={`${isActive('/') ? styles.active : ''}`}>
            <Link to="/" onClick={toggleDrawer}>
              <HomeIcon className={styles.home_icon} /> Home
            </Link>
          </li>
          {/* <li className={`${isActive('/about') ? styles.active : ''}`}>
            <Link to="/about" onClick={toggleDrawer}>
              <PeopleIcon className={styles.people_icon} /> Quem Somos
            </Link>
          </li> */}
          <li className={`${isActive('/camera') ? styles.active : ''}`}>
            <Link to={window.location.pathname} onClick={handleContractCameraWhatsapp}>
              <CameraIcon className={styles.camera_icon} /> Contratar Câmera
            </Link>
          </li>
          <li className={`${isActive('/videos') ? styles.active : ''}`}>
            <Link to="/videos" onClick={toggleDrawer}>
              <VideoIcon className={styles.videos_icon} /> Vídeos
            </Link>
          </li>
          <li className={`${isActive('/livestream') ? styles.active : ''}`}>
            <Link to="/livestream" onClick={toggleDrawer}>
              <LiveTvIcon className={styles.videos_icon} /> Livestream
            </Link>
          </li>
          {isAdminUser(user?.email) && (
            <li className={`${isActive('/gestor') ? styles.active : ''}`}>
              <Link to="/gestor" onClick={toggleDrawer}>
                <DashboardIcon className={styles.videos_icon} /> Painel do Gestor
              </Link>
            </li>
          )}
          {/* <li className={`${isActive('/contact') ? styles.active : ''}`}>
            <Link to="/contact" onClick={toggleDrawer}>
              <MailIcon className={styles.mail_icon} /> Contato
            </Link>
          </li> */}
          {/* <li className={`${isActive('/faq') ? styles.active : ''}`}>
            <Link to="/faq" onClick={toggleDrawer}>
              <FAQIcon className={styles.faq_icon} /> FAQ
            </Link>
          </li> */}
          {hasAccessToken && (
            <li>
              <Link to="/login" onClick={onSignOff}>
                <SignoutIcon className={styles.faq_icon} /> Sair
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

type NavbarProps = {
  menuTextColor: 'white' | 'black' | 'transparent';
};

function Navbar({ menuTextColor }: NavbarProps) {
  const { toggleDrawer } = useDrawer();
  const { windowWidth } = useWindowWidth();
  const location = useLocation();
  const navigate = useNavigate();
  const auth = getAuth();
  const hasAccessToken = !!localStorage.getItem('accessToken');
  // reativo: auth.currentUser é null no primeiro render, antes do Firebase iniciar
  const [userEmail, setUserEmail] = useState<string | null>(auth.currentUser?.email ?? null);
  useEffect(() => onAuthStateChanged(auth, (u) => setUserEmail(u?.email ?? null)), [auth]);

  const isActive = (path: string) => location.pathname === path;

  const onSignOff = () => {
    signOut(auth).then(() => {
      localStorage.removeItem('accessToken');
      navigate('/');
    });
  };

  const DesktopNavbar = () => (
    <nav className={`${styles.navbar} ${styles[`navbar_${menuTextColor}`]}`}>
      <div className={`${styles.navbar_container_menu}`}>
        <Link to="/" className={styles.navbar_logo}>
          <LogoIcon />
        </Link>
        <Link
          to="/"
          className={`${styles.navbar_links} ${styles[`navbar_links_${menuTextColor}`]} ${isActive('/') ? styles.active : ''}`}>
          Home
        </Link>
        <Link
          to={window.location.pathname}
          className={`${styles.navbar_links} ${styles[`navbar_links_${menuTextColor}`]} ${isActive('/contract-camera') ? styles.active : ''}`}
          onClick={handleContractCameraWhatsapp}>
          Contratar Câmera
        </Link>
        <Link
          to="/videos"
          className={`${styles.navbar_links} ${styles[`navbar_links_${menuTextColor}`]} ${isActive('/videos') ? styles.active : ''}`}>
          Vídeos
        </Link>
        <Link
          to="/livestream"
          className={`${styles.navbar_links} ${styles[`navbar_links_${menuTextColor}`]} ${isActive('/livestream') ? styles.active : ''}`}>
          Livestream
        </Link>
        {isAdminUser(userEmail) && (
          <Link
            to="/gestor"
            className={`${styles.navbar_links} ${styles[`navbar_links_${menuTextColor}`]} ${isActive('/gestor') ? styles.active : ''}`}>
            Painel do Gestor
          </Link>
        )}
      </div>
      <div className={styles.navbar_container_login}>
        {/* TODO: Review this part when is OK the profile */}
        {hasAccessToken ? (
          <Button text="Sair" backgroundColor="black" onClick={onSignOff} />
        ) : (
          <Button text="Login" backgroundColor="white" href="/login" />
        )}
      </div>
    </nav>
  );

  const MobileNavbar = () => (
    <nav className={`${styles.navbar} ${styles[`navbar_${menuTextColor}`]}`}>
      <Link to="/" className={styles.navbar_logo}>
        <LogoMinimalIcon />
      </Link>
      <MenuIcon
        style={{
          height: 40,
          width: 40,
          color: menuTextColor === 'transparent' ? 'white' : 'black'
        }}
        onClick={toggleDrawer}
      />
    </nav>
  );

  return windowWidth >= 768 ? <DesktopNavbar /> : <MobileNavbar />;
}

export default Navbar;
